import { useState } from "react";
import { feedCards } from "@/mocks/baogua";

const tabs = ["全部", "现场直击", "综艺现场", "剧组内幕", "明星绯闻", "音乐圈", "影视战报"];

export default function DeepFeed() {
  const [tab, setTab] = useState("全部");
  const list = tab === "全部" ? feedCards : feedCards.filter((c) => c.category === tab);

  return (
    <section id="deep" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
              <i className="ri-file-text-line"></i> 深度内容
            </span>
            <h2 className="mt-3 text-2xl md:text-4xl font-bold text-foreground-950">
              把瓜吃透的<span className="font-display text-primary-500">深度爆料</span>
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              不止标题党，我们用现场素材与行业视角把一个瓜拆开、揉碎、讲明白。
            </p>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-2">
          {tabs.map((t) => (
            <button key={t} onClick={() => setTab(t)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition ${tab === t ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-700 hover:bg-background-200/70"}`}>
              {t}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((card) => (
            <article key={card.id} className="group flex flex-col overflow-hidden rounded-2xl bg-background-50 transition hover:-translate-y-1">
              <div className="relative h-40 w-full overflow-hidden md:h-44">
                <img src={card.image} alt={card.title} className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
                <span className="absolute left-3 top-3 rounded-full bg-foreground-950/55 px-2.5 py-1 text-xs font-semibold text-background-50 backdrop-blur">
                  {card.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-600 transition md:text-base">
                  {card.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-[13px]">{card.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{card.read}</span>
                  <span className="flex items-center gap-3">
                    <span className="text-foreground-400">{card.time}</span>
                    <span className="flex items-center gap-1 font-semibold text-accent-600"><i className="ri-fire-line"></i>{card.hot}</span>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}